import { render, staticRenderFns } from "./WalletActivityList.vue?vue&type=template&id=8bdcc0e0&"
import script from "./WalletActivityList.vue?vue&type=script&lang=js&"
export * from "./WalletActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports